var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"bg-primary text-dark py-1 px-3 rounded-lg mx-1 my-1",on:{"click":function($event){return _vm.insertCaracter()}}},[_vm._v(_vm._s(this.char))])
}
var staticRenderFns = []

export { render, staticRenderFns }